var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIconGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00052 8.94167L4.73385 12.2083C4.61163 12.3306 4.45608 12.3917 4.26719 12.3917C4.0783 12.3917 3.92274 12.3306 3.80052 12.2083C3.6783 12.0861 3.61719 11.9306 3.61719 11.7417C3.61719 11.5528 3.6783 11.3972 3.80052 11.275L7.06719 8.00833L3.80052 4.74167C3.6783 4.61944 3.61719 4.46389 3.61719 4.275C3.61719 4.08611 3.6783 3.93056 3.80052 3.80833C3.92274 3.68611 4.0783 3.625 4.26719 3.625C4.45608 3.625 4.61163 3.68611 4.73385 3.80833L8.00052 7.075L11.2672 3.80833C11.3894 3.68611 11.545 3.625 11.7339 3.625C11.9227 3.625 12.0783 3.68611 12.2005 3.80833C12.3227 3.93056 12.3839 4.08611 12.3839 4.275C12.3839 4.46389 12.3227 4.61944 12.2005 4.74167L8.93385 8.00833L12.2005 11.275C12.3227 11.3972 12.3839 11.5528 12.3839 11.7417C12.3839 11.9306 12.3227 12.0861 12.2005 12.2083C12.0783 12.3306 11.9227 12.3917 11.7339 12.3917C11.545 12.3917 11.3894 12.3306 11.2672 12.2083L8.00052 8.94167Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIconGray);
export default __webpack_public_path__ + "static/media/x-icon-gray.301bbf69766a7ca3e44fb96587453ee4.svg";
export { ForwardRef as ReactComponent };